import { SimpleTooltip } from "@rio-cloud/rio-uikit";

interface Props {
  text: string;
  icon?: string;
  background: string;
  disabled?: boolean;
}

const Chip = ({ text, icon, background, disabled }: Props) => {
  const content: Record<string, string> = {
    'truckerassist': disabled
      ? 'Não possui Trucker Assist'
      : 'Possui Trucker Assist atualizado',
    'minhaequipe': disabled
      ? 'Motorista da frota não possui usuário de acesso ao RIO'
      : 'Motorista da frota possui usuário de acesso ao RIO',
    'gestordafrota': 'Administrador da frota'
  };

  const chipContent = !disabled ? (
    <div className={`label ${background} label-filled label-condensed`}>
      <div className="display-flex align-items-center gap-2">
        {icon && <div className={`${icon} text-size-8 margin-ritgh-4`} />}
        <span className="text-capitalize">{text}</span>
      </div>
    </div>
  ) : (
    <div className="label bg-gray label-filled label-condensed border-color-lighter bg-lighter">
      <div className="display-flex align-items-center gap-2">
        {icon && (
          <div className={`${icon} text-size-8 margin-ritgh-4 text-color-dark`} />
        )}
        <span className="text-capitalize text-color-dark">{text}</span>
      </div>
    </div>
  );

  return (
    <SimpleTooltip
      content={
        <span>
          {content[text?.toLocaleLowerCase()?.replace(/\s+/g, "")]}
        </span>
      }
      placement="bottom"
    >
      {chipContent}
    </SimpleTooltip>
  );
};

export default Chip;
